(function () {
    const DAYS_PER_MONTH = 30.4;
    const DAYS_PER_YEAR = 365;
    const OZ_TO_GRAMS = 28.3495;

    const BENCHMARKS = {
      coffeeBarCost: 1524.0,
      coffeeBagPrice: 23.99,
      coffeeBagSizeOz: 28,
      coffeeGramsPerDrink: 18,
      milkContainerPrice: 4.07,
      milkContainerSizeOz: 128,
      milkOzPerDrink: 4,
      monthlyFilterCost: 12.67,
      drinksCount: 2,
      drinksFrequency: "day",
      cafePrice: 5.0,
      useSeparateDrinkCounts: false,
      homeDrinksCount: 2,
      homeDrinksFrequency: "day",
      cafeDrinksCount: 2,
      cafeDrinksFrequency: "day",
    };

    const drinksCountInput = document.getElementById("drinksCount");
    const drinksFrequencyInput = document.getElementById("drinksFrequency");
    const cafePriceInput = document.getElementById("cafePrice");

    const useSeparateDrinkCountsInput = document.getElementById("useSeparateDrinkCounts");
    const separateDrinkCountsFields = document.getElementById("separateDrinkCountsFields");
    const homeDrinksCountInput = document.getElementById("homeDrinksCount");
    const homeDrinksFrequencyInput = document.getElementById("homeDrinksFrequency");
    const cafeDrinksCountInput = document.getElementById("cafeDrinksCount");
    const cafeDrinksFrequencyInput = document.getElementById("cafeDrinksFrequency");

    const coffeeBarCostInput = document.getElementById("coffeeBarCost");
    const coffeeBagPriceInput = document.getElementById("coffeeBagPrice");
    const coffeeBagSizeOzInput = document.getElementById("coffeeBagSizeOz");
    const coffeeGramsPerDrinkInput = document.getElementById("coffeeGramsPerDrink");
    const milkContainerPriceInput = document.getElementById("milkContainerPrice");
    const milkContainerSizeOzInput = document.getElementById("milkContainerSizeOz");
    const milkOzPerDrinkInput = document.getElementById("milkOzPerDrink");
    const monthlyFilterCostInput = document.getElementById("monthlyFilterCost");
    const overrideMonthlyHomeCostInput = document.getElementById("overrideMonthlyHomeCost");
    const dailySpendInput = document.getElementById("dailySpend");
    const applyBenchmarkBtn = document.getElementById("applyBenchmarkBtn");

    const startupCostEl = document.getElementById("startupCost");
    const homeCostUsedLabelEl = document.getElementById("homeCostUsedLabel");
    const estimatedHomeCostEl = document.getElementById("estimatedHomeCost");
    const estimatedBeansCostEl = document.getElementById("estimatedBeansCost");
    const coffeeBagsNeededEl = document.getElementById("coffeeBagsNeeded");
    const estimatedMilkCostEl = document.getElementById("estimatedMilkCost");
    const milkContainersNeededEl = document.getElementById("milkContainersNeeded");
    const estimatedFilterCostEl = document.getElementById("estimatedFilterCost");
    const monthlyCafeSpendEl = document.getElementById("monthlyCafeSpend");
    const yearlyCafeSpendEl = document.getElementById("yearlyCafeSpend");
    const monthlySavingsEl = document.getElementById("monthlySavings");
    const annualOngoingSavingsEl = document.getElementById("annualOngoingSavings");
    const firstYearSavingsEl = document.getElementById("firstYearSavings");
    const breakEvenMonthsEl = document.getElementById("breakEvenMonths");
    const savingsPerDrinkEl = document.getElementById("savingsPerDrink");
    const threeYearSavingsEl = document.getElementById("threeYearSavings");
    const fiveYearSavingsEl = document.getElementById("fiveYearSavings");

    const firstYearLabelEl = document.getElementById("firstYearLabel");
    const threeYearLabelEl = document.getElementById("threeYearLabel");
    const fiveYearLabelEl = document.getElementById("fiveYearLabel");
    const calcSummaryEl = document.getElementById("calcSummary");

    const currentCoffeeBagEl = document.getElementById("currentCoffeeBag");
    const currentCoffeeBagDetailEl = document.getElementById("currentCoffeeBagDetail");
    const currentMilkEl = document.getElementById("currentMilk");
    const currentMilkDetailEl = document.getElementById("currentMilkDetail");
    const currentFilterEl = document.getElementById("currentFilter");
    const currentFilterDetailEl = document.getElementById("currentFilterDetail");

    const estimatedHomeCostBreakdownEl = document.getElementById("estimatedHomeCostBreakdown");
    const estimatedBeansCostBreakdownEl = document.getElementById("estimatedBeansCostBreakdown");
    const estimatedMilkCostBreakdownEl = document.getElementById("estimatedMilkCostBreakdown");
    const estimatedFilterCostBreakdownEl = document.getElementById("estimatedFilterCostBreakdown");

    function formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    }

    function formatCount(value, singular, plural) {
      return value + " " + (value === 1 ? singular : plural);
    }

    function formatPlainNumber(value, decimals) {
      if (Number.isInteger(value)) return String(value);
      return value.toFixed(decimals);
    }

    function getNumber(input) {
      const value = parseFloat(input.value);
      return isNaN(value) ? 0 : value;
    }

    function getDrinksPerDayEquivalent(count, frequency) {
      return frequency === "week" ? count / 7 : count;
    }

    function getDrinksPerMonth(count, frequency) {
      return getDrinksPerDayEquivalent(count, frequency) * DAYS_PER_MONTH;
    }

    function toggleSeparateDrinkFields() {
      const isEnabled = useSeparateDrinkCountsInput.checked;
      separateDrinkCountsFields.hidden = !isEnabled;
      separateDrinkCountsFields.classList.toggle("is-hidden", !isEnabled);
    }

    function setValueState(element, value) {
      element.classList.remove("is-positive", "is-negative");

      if (value > 0) {
        element.classList.add("is-positive");
      } else if (value < 0) {
        element.classList.add("is-negative");
      }
    }

    function setDynamicLabel(labelElement, value, positiveText, negativeText) {
      labelElement.textContent = value >= 0 ? positiveText : negativeText;
    }

    function setOutput(element, value) {
      element.value = value;
      element.textContent = value;
    }

    function applyBenchmarks() {
      drinksCountInput.value = BENCHMARKS.drinksCount;
      drinksFrequencyInput.value = BENCHMARKS.drinksFrequency;
      cafePriceInput.value = BENCHMARKS.cafePrice.toFixed(2);

      useSeparateDrinkCountsInput.checked = BENCHMARKS.useSeparateDrinkCounts;
      homeDrinksCountInput.value = BENCHMARKS.homeDrinksCount;
      homeDrinksFrequencyInput.value = BENCHMARKS.homeDrinksFrequency;
      cafeDrinksCountInput.value = BENCHMARKS.cafeDrinksCount;
      cafeDrinksFrequencyInput.value = BENCHMARKS.cafeDrinksFrequency;

      coffeeBarCostInput.value = BENCHMARKS.coffeeBarCost.toFixed(2);
      coffeeBagPriceInput.value = BENCHMARKS.coffeeBagPrice.toFixed(2);
      coffeeBagSizeOzInput.value = BENCHMARKS.coffeeBagSizeOz.toFixed(1);
      coffeeGramsPerDrinkInput.value = BENCHMARKS.coffeeGramsPerDrink;
      milkContainerPriceInput.value = BENCHMARKS.milkContainerPrice.toFixed(2);
      milkContainerSizeOzInput.value = BENCHMARKS.milkContainerSizeOz;
      milkOzPerDrinkInput.value = BENCHMARKS.milkOzPerDrink;
      monthlyFilterCostInput.value = BENCHMARKS.monthlyFilterCost.toFixed(2);

      overrideMonthlyHomeCostInput.value = "";
      dailySpendInput.value = "";

      toggleSeparateDrinkFields();
      calculate();
    }

    function calculate() {
      const useSeparateDrinkCounts = useSeparateDrinkCountsInput.checked;

      const sharedDrinksCount = getNumber(drinksCountInput);
      const sharedDrinksFrequency = drinksFrequencyInput.value;

      const homeDrinksCount = useSeparateDrinkCounts
        ? getNumber(homeDrinksCountInput)
        : sharedDrinksCount;
      const homeDrinksFrequency = useSeparateDrinkCounts
        ? homeDrinksFrequencyInput.value
        : sharedDrinksFrequency;

      const cafeDrinksCount = useSeparateDrinkCounts
        ? getNumber(cafeDrinksCountInput)
        : sharedDrinksCount;
      const cafeDrinksFrequency = useSeparateDrinkCounts
        ? cafeDrinksFrequencyInput.value
        : sharedDrinksFrequency;

      const cafePrice = getNumber(cafePriceInput);

      const coffeeBarCost = getNumber(coffeeBarCostInput);
      const coffeeBagPrice = getNumber(coffeeBagPriceInput);
      const coffeeBagSizeOz = getNumber(coffeeBagSizeOzInput);
      const coffeeGramsPerDrink = getNumber(coffeeGramsPerDrinkInput);
      const milkContainerPrice = getNumber(milkContainerPriceInput);
      const milkContainerSizeOz = getNumber(milkContainerSizeOzInput);
      const milkOzPerDrink = getNumber(milkOzPerDrinkInput);
      const monthlyFilterCost = getNumber(monthlyFilterCostInput);

      const overrideMonthlyHomeCost = parseFloat(overrideMonthlyHomeCostInput.value);
      const hasHomeCostOverride =
        overrideMonthlyHomeCostInput.value !== "" &&
        !isNaN(overrideMonthlyHomeCost);

      const manualDailySpend = parseFloat(dailySpendInput.value);
      const hasManualDailySpend =
        dailySpendInput.value !== "" && !isNaN(manualDailySpend);

      const homeDrinksPerDayEquivalent = getDrinksPerDayEquivalent(
        homeDrinksCount,
        homeDrinksFrequency
      );
      const cafeDrinksPerDayEquivalent = getDrinksPerDayEquivalent(
        cafeDrinksCount,
        cafeDrinksFrequency
      );

      const homeDrinksPerMonth = getDrinksPerMonth(
        homeDrinksCount,
        homeDrinksFrequency
      );

      const coffeeBagSizeGrams = coffeeBagSizeOz * OZ_TO_GRAMS;
      const coffeeGramsNeeded = homeDrinksPerMonth * coffeeGramsPerDrink;
      const coffeeBagsNeeded =
        coffeeBagSizeGrams > 0
          ? Math.ceil(coffeeGramsNeeded / coffeeBagSizeGrams)
          : 0;
      const estimatedBeansCost = coffeeBagsNeeded * coffeeBagPrice;

      const milkOzNeeded = homeDrinksPerMonth * milkOzPerDrink;
      const milkContainersNeeded =
        milkContainerSizeOz > 0
          ? Math.ceil(milkOzNeeded / milkContainerSizeOz)
          : 0;
      const estimatedMilkCost = milkContainersNeeded * milkContainerPrice;

      const estimatedFilterCost = monthlyFilterCost;
      const ingredientBasedHomeCost =
        estimatedBeansCost + estimatedMilkCost + estimatedFilterCost;

      const homeCostParts = [];

      if (estimatedBeansCost > 0 && coffeeBagsNeeded > 0) {
        homeCostParts.push(formatCount(coffeeBagsNeeded, 'bag', 'bags') + ' of coffee');
      }

      if (estimatedMilkCost > 0 && milkContainersNeeded > 0) {
        homeCostParts.push(formatCount(milkContainersNeeded, 'gallon', 'gallons') + ' of milk');
      }

      if (estimatedFilterCost > 0) {
        homeCostParts.push('1 filter');
      }

      let homeCostBreakdownText = '';

      if (homeCostParts.length === 0) {
        homeCostBreakdownText = 'your current ingredient settings';
      } else if (homeCostParts.length === 1) {
        homeCostBreakdownText = homeCostParts[0];
      } else if (homeCostParts.length === 2) {
        homeCostBreakdownText = homeCostParts[0] + ' and ' + homeCostParts[1];
      } else {
        homeCostBreakdownText = homeCostParts.slice(0, -1).join(', ') + ', and ' + homeCostParts[homeCostParts.length - 1];
      }

      estimatedHomeCostBreakdownEl.textContent = 'Based on ' + homeCostBreakdownText;

      estimatedBeansCostBreakdownEl.textContent =
        formatCount(coffeeBagsNeeded, "coffee bag", "coffee bags") +
        " × " +
        formatCurrency(coffeeBagPrice) +
        " each";

      estimatedMilkCostBreakdownEl.textContent =
        formatCount(milkContainersNeeded, "gallon", "gallons") +
        " × " +
        formatCurrency(milkContainerPrice) +
        " each";

      estimatedFilterCostBreakdownEl.textContent =
        "1 filter × " + formatCurrency(estimatedFilterCost);

      const monthlyHomeCostUsed = hasHomeCostOverride
        ? overrideMonthlyHomeCost
        : ingredientBasedHomeCost;

      const startupCost = coffeeBarCost;
      const calculatedDailySpend = cafeDrinksPerDayEquivalent * cafePrice;
      const dailySpend = hasManualDailySpend ? manualDailySpend : calculatedDailySpend;

      const monthlyCafeSpend = dailySpend * DAYS_PER_MONTH;
      const yearlyCafeSpend = dailySpend * DAYS_PER_YEAR;

      const monthlySavings = monthlyCafeSpend - monthlyHomeCostUsed;
      const yearlyHomeCost = monthlyHomeCostUsed * 12;
      const annualOngoingSavings = yearlyCafeSpend - yearlyHomeCost;
      const firstYearSavings = yearlyCafeSpend - (startupCost + yearlyHomeCost);
      const threeYearSavings = annualOngoingSavings * 3 - startupCost;
      const fiveYearSavings = annualOngoingSavings * 5 - startupCost;

      const effectiveCafePricePerDrink =
        hasManualDailySpend && cafeDrinksPerDayEquivalent > 0
          ? dailySpend / cafeDrinksPerDayEquivalent
          : cafePrice;

      const homeCostPerDrink =
        homeDrinksPerMonth > 0 ? monthlyHomeCostUsed / homeDrinksPerMonth : 0;

      const savingsPerDrink =
        homeDrinksPerMonth > 0
          ? effectiveCafePricePerDrink - homeCostPerDrink
          : 0;

      setOutput(startupCostEl, formatCurrency(startupCost));
      setOutput(estimatedHomeCostEl, formatCurrency(monthlyHomeCostUsed));
      setOutput(estimatedBeansCostEl, formatCurrency(estimatedBeansCost));
      setOutput(coffeeBagsNeededEl, formatCount(coffeeBagsNeeded, "bag", "bags"));
      setOutput(estimatedMilkCostEl, formatCurrency(estimatedMilkCost));
      setOutput(
        milkContainersNeededEl,
        formatCount(milkContainersNeeded, "gallon", "gallons")
      );
      setOutput(estimatedFilterCostEl, formatCurrency(estimatedFilterCost));
      setOutput(monthlyCafeSpendEl, formatCurrency(monthlyCafeSpend));
      setOutput(yearlyCafeSpendEl, formatCurrency(yearlyCafeSpend));
      setOutput(monthlySavingsEl, formatCurrency(monthlySavings));
      setOutput(annualOngoingSavingsEl, formatCurrency(annualOngoingSavings));
      setOutput(firstYearSavingsEl, formatCurrency(firstYearSavings));
      setOutput(threeYearSavingsEl, formatCurrency(threeYearSavings));
      setOutput(fiveYearSavingsEl, formatCurrency(fiveYearSavings));

      if (homeDrinksPerMonth > 0) {
        setOutput(savingsPerDrinkEl, formatCurrency(savingsPerDrink));
      } else {
        setOutput(savingsPerDrinkEl, "—");
      }

      currentCoffeeBagEl.textContent =
        formatCurrency(coffeeBagPrice) +
        " / " +
        formatPlainNumber(coffeeBagSizeOz, 1) +
        " oz";

      currentCoffeeBagDetailEl.textContent =
        formatPlainNumber(coffeeGramsPerDrink, 1) + "g of coffee per drink";

      currentMilkEl.textContent =
        formatCurrency(milkContainerPrice) +
        " / " +
        formatPlainNumber(milkContainerSizeOz, 1) +
        " oz";

      currentMilkDetailEl.textContent =
        formatPlainNumber(milkOzPerDrink, 1) + "oz of milk per drink";

      currentFilterEl.textContent = formatCurrency(estimatedFilterCost) + " / month";
      currentFilterDetailEl.textContent =
        "Fixed monthly average for water filters";

      if (hasHomeCostOverride) {
        homeCostUsedLabelEl.textContent = "Monthly home coffee cost used in savings";
      } else {
        homeCostUsedLabelEl.textContent = "Estimated monthly home coffee cost";
      }

      setDynamicLabel(
        firstYearLabelEl,
        firstYearSavings,
        "First-year net savings",
        "First-year net cost remaining"
      );

      setDynamicLabel(
        threeYearLabelEl,
        threeYearSavings,
        "3-year savings",
        "3-year net cost remaining"
      );

      setDynamicLabel(
        fiveYearLabelEl,
        fiveYearSavings,
        "5-year savings",
        "5-year net cost remaining"
      );

      setValueState(monthlySavingsEl, monthlySavings);
      setValueState(annualOngoingSavingsEl, annualOngoingSavings);
      setValueState(firstYearSavingsEl, firstYearSavings);
      setValueState(threeYearSavingsEl, threeYearSavings);
      setValueState(fiveYearSavingsEl, fiveYearSavings);
      setValueState(savingsPerDrinkEl, savingsPerDrink);

      if (monthlySavings > 0) {
        const breakEvenMonths = startupCost / monthlySavings;
        setOutput(breakEvenMonthsEl, breakEvenMonths.toFixed(1) + " months");
      } else {
        setOutput(breakEvenMonthsEl, "No payback");
      }

      if (hasHomeCostOverride) {
        calcSummaryEl.textContent =
          "Using your override monthly home coffee cost of " +
          formatCurrency(monthlyHomeCostUsed) +
          ", you could save about " +
          formatCurrency(monthlySavings) +
          " per month. The ingredient assumptions in Savings breakdown are still shown for reference.";
      } else if (monthlySavings > 0) {
        if (useSeparateDrinkCounts) {
          calcSummaryEl.textContent =
            "Based on " +
            cafeDrinksCount +
            " café drinks per " +
            cafeDrinksFrequency +
            " at " +
            formatCurrency(cafePrice) +
            " each, and " +
            homeDrinksCount +
            " at-home drinks per " +
            homeDrinksFrequency +
            ", your estimated monthly home coffee cost is about " +
            formatCurrency(monthlyHomeCostUsed) +
            " (" +
            formatCurrency(estimatedBeansCost) +
            " beans + " +
            formatCurrency(estimatedMilkCost) +
            " milk + " +
            formatCurrency(estimatedFilterCost) +
            " water filter), and you could save about " +
            formatCurrency(monthlySavings) +
            " per month.";
        } else {
          calcSummaryEl.textContent =
            "Based on " +
            sharedDrinksCount +
            " drinks per " +
            sharedDrinksFrequency +
            " at " +
            formatCurrency(cafePrice) +
            " each, your estimated monthly home coffee cost is about " +
            formatCurrency(monthlyHomeCostUsed) +
            " (" +
            formatCurrency(estimatedBeansCost) +
            " beans + " +
            formatCurrency(estimatedMilkCost) +
            " milk + " +
            formatCurrency(estimatedFilterCost) +
            " water filter), and you could save about " +
            formatCurrency(monthlySavings) +
            " per month.";
        }
      } else if (monthlySavings < 0) {
        calcSummaryEl.textContent =
          "At these inputs, your estimated monthly home coffee cost is higher than your café spending, so there is no break-even point yet.";
      } else {
        calcSummaryEl.textContent =
          "At these inputs, your monthly home coffee cost is about the same as your café spending.";
      }
    }

    [
      drinksCountInput,
      cafePriceInput,
      homeDrinksCountInput,
      cafeDrinksCountInput,
      coffeeBarCostInput,
      coffeeBagPriceInput,
      coffeeBagSizeOzInput,
      coffeeGramsPerDrinkInput,
      milkContainerPriceInput,
      milkContainerSizeOzInput,
      milkOzPerDrinkInput,
      monthlyFilterCostInput,
      overrideMonthlyHomeCostInput,
      dailySpendInput,
    ].forEach((input) => {
      input.addEventListener("input", calculate);
    });

    [
      drinksFrequencyInput,
      homeDrinksFrequencyInput,
      cafeDrinksFrequencyInput,
    ].forEach((input) => {
      input.addEventListener("change", calculate);
    });

    useSeparateDrinkCountsInput.addEventListener("change", function () {
      toggleSeparateDrinkFields();
      calculate();
    });

    if (applyBenchmarkBtn) {
      applyBenchmarkBtn.addEventListener("click", applyBenchmarks);
    }

    toggleSeparateDrinkFields();
    calculate();
  })();